import urbaniceLogo from '../../src/image/logo_urbanice_white.png'

export default {
  apiUrl: 'http://yoursite.com/api/',
};

const siteConfig = {
  siteName: 'Urbanice Niti',
  siteIcon: urbaniceLogo, //'ion-flash',
  footerText: 'Urbanice Niti ©2019-2024 Created by Urbanice.app',
  version: '3.6.13-6',
  DEBUG: false, //false, true
  VMS_STAGE: 'vms', //'prod':'vms','dev':'vms-dev'
  VMS_COUPON_STAGE: 'vms-coupon', //vms-coupon-dev : vms-coupon
  PATROL_STAGE: 'patrol', //'prod':'patrol','dev':'patrol-dev'
  INCIDENT_STAGE: 'incident-report', //'prod':'incident-report','dev':'incident-report-dev'
};

const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};

const language = 'thai'; //english

const jwtConfig = {
  fetchUrl: '/api/',
  secretKey: 'secretKey',
};

export { siteConfig, language, themeConfig, jwtConfig };
